import { combineReducers } from 'lib/redux';
import order from 'features/order/Order.reducer';
import placeOrder from 'features/placeOrder/PlaceOrder.reducer';
import orderAddresses from 'features/placeOrder/OrderAddresses.reducer';
import orderSubmitted from 'features/orderSubmitted/OrderSubmitted.reducer';
import finalizeOrder from 'features/finalizeOrder/FinalizeOrder.reducer';
import orderHistory from 'features/orderHistory/OrderHistory.reducer';
import userData from 'features/userData/UserData.reducer';
import userEntitlements from 'features/user-entitlements/UserEntitlements.reducer';
import cancelOrder from 'features/cancel-order-dialog/CancelOrder.reducer';
import sitemap from 'features/sitemap/Sitemap.reducer';
import reportDetailsPage from 'features/reportDetails/ReportDetailsPage.reducer';
import featureFlag from 'features/featureFlag/featureFlag.reducer';
import pitchEditor from 'features/pitchEditor/PitchEditor.reducer';
import orderPreference from 'features/orderPreferences/OrderPreference.reducer';
import accountsDeletion from 'features/accountsDeletion/AccountsDeletion.reducer';
import billingInformation from 'features/billingInfomation/BillingInformation.reducer';
import contactInformation from 'features/contactInformation/ContactInformation.reducer';
import uploadInformation from 'features/uploadInformation/UploadInformation.reducer';
import notificationBar from 'features/notificationBar/NotificationBar.reducer';
import textAlertSettings from 'features/textAlertSettings/TextAlertSettings.reducer';
import srs from 'features/order/components/SRS/SRS.reducer';
import managePaymentOptions from 'features/managePaymentOptions/ManagePaymentOptions.reducer';
import analyticsDashboard from 'features/analyticsDashboard/AnalyticsDashboard.reducer';
import reportsChange from 'features/reportTypeChange/ReportsChange.reducer';
import nonPersisted from './nonPersisted/NonPersisted.reducer';

/**
 * Root reducer, which is a combination of several reducers
 */

const rootReducer = combineReducers({
  order,
  placeOrder,
  orderAddresses,
  orderSubmitted,
  finalizeOrder,
  orderHistory,
  userData,
  userEntitlements,
  cancelOrder,
  sitemap,
  reportDetailsPage,
  featureFlag,
  pitchEditor,
  orderPreference,
  accountsDeletion,
  billingInformation,
  contactInformation,
  uploadInformation,
  notificationBar,
  nonPersisted,
  textAlertSettings,
  srs,
  managePaymentOptions,
  analyticsDashboard,
  reportsChange,
});

export default rootReducer;
